import * as _ from 'lodash';
import { CalibrationGeneralValue } from '../calibrations/calibration-general-value.model';
import tableDictionary from './dictionary/calibration-general.dictionary';
import tableSettings from './settings/general-table.settings';
import { BaseTable } from '../common-models/base-table.model';
import { TableType } from '../../../shared/enums';

export class GeneralTable extends BaseTable {
    constructor() {
        super(tableSettings, tableDictionary, true);
        this.calibrationType = TableType.CALIBRATION_GENERAL;
    }

    updateData(savedData: CalibrationGeneralValue[]): boolean {
        if (!this.isInitialized) {
            return false;
        }
        savedData.forEach(updatedCalibrationGeneral => {
            const calibrationGeneralIndex = _.findIndex(this.table, cell => {
                return (
                    cell.value.currentState.ZoneCombinationId === updatedCalibrationGeneral.ZoneCombinationId &&
                    cell.value.currentState.OverlayTypologyId === updatedCalibrationGeneral.OverlayTypologyId
                );
            });
            this.table[calibrationGeneralIndex].value = new CalibrationGeneralValue(
                updatedCalibrationGeneral,
                this.settings.fieldValidation
            );
        });
        return true;
    }
}
